export interface IPayrollRecord {
    id: number;
    payrollImportId: number;
    ssn: string;
    lastFourSSN: string;
    name: string;
    firstName: string;
    lastName: string;
    middleInitials: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    state: string;
    zip: string;
    zip4: string;
    systemCode: string;
    payPeriodEndDate: Date;
    locationCode: string;
    planCode: string;
    departmentCode: string;
    actualAnnualCompensation: number;
    employeeContribution: number;
    actualEarnableCompensation: number;
    hoursWorked: number;
    standardHours: number;
    percentFullTime: number;
    payPeriodBaseSalary: number;
    issue: string;
}

export class PayrollRecord {
    Id: number;
    PayrollImportId: number;
    SSN: string;
    LastFourSSN: string;
    Name: string;
    FirstName: string;
    LastName: string;
    MiddleInitials: string;
    AddressLine1: string;
    AddressLine2: string;
    City: string;
    State: string;
    Zip: string;
    Zip4: string;
    SystemCode: string;
    PayPeriodEndDate: Date;
    LocationCode: string;
    PlanCode: string;
    DepartmentCode: string;
    ActualAnnualCompensation: number;
    EmployeeContribution: number;
    ActualEarnableCompensation: number;
    HoursWorked: number;
    StandardHours: number;
    PercentFullTime: number;
    PayPeriodBaseSalary: number;
    Issue: string;
}
export class StagingPayrollRecord {
    Id: number;
    PayrollImportId: number;
    SSN: string;
    FirstName: string;
    LastName: string;
    MiddleInitials: string;
    AddressLine1: string;
    AddressLine2: string;
    City: string;
    State: string;
    Zip: string;
    Zip4: string;
    SystemCode: string;
    PayPeriodEndDate: string;
    LocationCode: string;
    PlanCode: string;
    DepartmentCode: string;
    ActualAnnualCompensation: number;
    EmployeeContribution: number;
    ActualEarnableCompensation: number;
    HoursWorked: number;
    StandardHours: number;
    PercentFullTime: number;
    PayPeriodBaseSalary: number;
    IsAddressChange = false;
    IsLocationChange = false;
    IsNameChange = false;
    IsNewMemberEnrollment = false;
    IsUnexpectedAmount = false;
    IsInvalid = false;
    Validated = true;
    PayrollImport: any;
    PayrollRecordErrors: any;
}
